import { get, post } from './request';

// 定义接口返回数据的类型
interface ApiResponse<T> {
    code: number;
    data: T;
    message: string;
}

// 发送验证码
export function sendVerificationCode(phone: string) {
    return get<ApiResponse<null>>(`/mall-user-web/user/store/registCode/${phone}`);
}

// 提交表单

export function submitForm(phone: string, code: string, inviteCode: string) {
    console.log("url:", (`/mall-user-web/user/store/registShop/${phone}/${code}/3/${inviteCode}`));
    return get<ApiResponse<null>>(`/mall-user-web/user/store/registShop/${phone}/${code}/3/${inviteCode}`);
}

// 绑定手机号（POST）
export function bindPhone(bindkey: string, phone: string) {
    return post<ApiResponse<null>>('/mall-user-web/wxMsg/api/bind-phone', { bindkey, phone });
}

